export const environment = {
  production: false,
  apiUrl: 'https://test-aoworkwear.customapi.structpim.com',
  pimUrl: 'https://aoworkwear-test.app.struct.com'
};